import React, { FC } from 'react'

//* utils
import { LocaleCodes } from '../../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../../models/components/announcement'
import { MenuGroup } from '../../../../models/others/menuGroup'
import { cnOverrideForm, cnPrivacyPolicy, cnWebinarTerms } from '../../../../utils/cn.utils'
import { generateThankYouPageURL } from '../../../../utils/link.utils'

//* components
import Layout from '../../../layouts/layout'
import { WebinarContent } from './subcomponents'

type Props = {
  pageContext: any
  path: string
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  browserLanguageData?: any
}

const WebinarPage: FC<Props> = ({
  pageContext,
  path,
  headerData,
  footerData,
  announcementData,
  browserLanguageData,
}) => {
  const pageData = pageContext.webinarData || null
  if (!pageData) return null

  const webinarData = {
    h1Title: pageData.h1Title || '',
    slug: pageData.slug || '/',
    seoMetadata: pageData.seoMetadata || null,
    useCase: pageData.useCase || '',
    marketoJsScript: pageData.marketoJsScript?.marketoJsScript || '',
    cnFormOverride: pageData.cnFormOverride || null,
    formOverride: pageData.formOverride || null,
    body: pageData.body || '',
    robot: {
      url: pageData.robotRelease?.image?.file?.url || '',
      alt: pageData.robotRelease?.image?.imageAlt || '',
      releaseLink: pageData.robotReleaseLink || '',
    },
    mainImage: {
      url: pageData.mainImage?.image?.file?.url || '/',
      alt: pageData.mainImage?.altText || '',
    },
    hero: {
      subtitle: pageData.heroSubtitle || '',
      textCentered: pageData.heroTextCentered || false,
      eyebrow: pageData.heroEyebrow || '',
      fontBlack: pageData.heroFontBlack,
    },
    microcopy: pageData.microcopy || {},
    formIntro: pageData.formIntro || '',
    category: {
      number: pageData.resourceCategory?.number,
    },
    finePrint: pageData.finePrint || '',
    greyTextBar: pageData.greyTextBar || false,
  }

  const locale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const thankYouPageUrl = generateThankYouPageURL('/g/thank-you-webinar', pageData.thankYouPage)

  cnOverrideForm(thankYouPageUrl)
  cnPrivacyPolicy()
  cnWebinarTerms()

  return (
    <Layout.Template
      lang={locale}
      minimalFooter={true}
      minimalHeader={true}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      browserLanguageData={browserLanguageData}
      pageType="webinar"
      slug={webinarData.slug}
      availableLocales={pageContext.availableLocales}>
      <div data-cy="Webinar">
        <WebinarContent
          webinarData={webinarData}
          availableLocales={pageContext.availableLocales}
          locale={locale}
          marketoFormData={pageContext.marketoFormData}
          thankYouPageUrl={thankYouPageUrl}
          path={path}
        />
      </div>
    </Layout.Template>
  )
}

export default WebinarPage
